export default __webpack_public_path__ + "../ckeditor/plugins/colordialog/dialogs/colordialog.js";